import { formatISO, startOfMonth, subDays } from "date-fns";

import { EvtStatsCard } from "components/stats/display-card";
import QueryError from "components/query-error";
import { Skeleton } from "ui/components/skeleton";
import { computeTimesheetStats } from "components/timesheet/dashboard/logs-overview/transformer";
import { fetchTimesheet } from "components/timesheet/dashboard/api";
import { formatHoursToTime } from "utils/timesheet";
import { timesheetKeys } from "components/timesheet/queries";
// modules/timesheet/pages/dashboard.jsx
import { useQuery } from "@tanstack/react-query";

export default function TimesheetDashboardStats() {
  const currentDay = new Date();
  const monthStart = formatISO(startOfMonth(currentDay), {
    representation: "date",
  });

  const weekStart = formatISO(subDays(currentDay, 7), {
    representation: "date",
  });

  const {
    data: monthData,
    isLoading: monthLoading,
    isError: monthError,
    refetch: refetchMonth,
  } = useQuery({
    queryKey: timesheetKeys.thisMonthTimesheet(monthStart),
    queryFn: () => fetchTimesheet({ startDate: monthStart }),
  });

  const {
    data: weekData,
    isLoading: weekLoading,
    isError: weekError,
    refetch: refetchWeek,
  } = useQuery({
    queryKey: timesheetKeys.last7DaysTimesheet(weekStart),
    queryFn: () => fetchTimesheet({ startDate: weekStart }),
  });

  const isLoading = monthLoading || weekLoading;
  const isError = monthError || weekError;

  if (isLoading) {
    return [...Array(4)].map((_, i) => (
      <Skeleton key={i} className="w-full h-32 rounded-xl" />
    ));
  }

  if (isError) {
    return (
      <QueryError
        message="Failed to load dashboard stats."
        onRetry={() => {
          refetchMonth();
          refetchWeek();
        }}
      />
    );
  }

  const { today, thisMonth } = computeTimesheetStats(monthData);
  const { yesterday, last7Days } = computeTimesheetStats(weekData);

  return (
    <>
      <EvtStatsCard label="Today" value={formatHoursToTime(today)} />
      <EvtStatsCard label="Yesterday" value={formatHoursToTime(yesterday)} />
      <EvtStatsCard label="Last 7 Days" value={formatHoursToTime(last7Days)} />
      <EvtStatsCard label="This Month" value={formatHoursToTime(thisMonth)} />
    </>
  );
}
